const Connect = require("react-redux").connect;
const PasswordReset = require("../components/PasswordReset");
const ResetAct = require("actions/reset-password");

const internals = {};

internals.connect = Connect(null, {
    onSubmit: ResetAct.resetPassword
});

module.exports = internals.connect(PasswordReset);



// WEBPACK FOOTER //
// ./src/routes/password-reset/containers/PasswordReset.js